// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1HourUserSchema = z.object({
  id: z.number().int().gt(0),
  email: z.coerce.string().min(1),
  name: z.coerce.string().min(1),
  avatar: z.object({
    large_retina: z.coerce.string().url(),
    large: z.coerce.string().url(),
    medium_retina: z.coerce.string().url(),
    medium: z.coerce.string().url(),
    small_retina: z.optional(z.coerce.string().url()),
    small: z.optional(z.coerce.string().url()),
    timeline: z.optional(z.coerce.string().url()),
  }),
  active: z.optional(z.boolean()),
  day_view_onboarded: z.optional(z.boolean()),
  memory_onboarded: z.optional(z.boolean()),
  created_at: z.string().datetime().nullish(),
  updated_at: z.string().datetime().nullish(),
  last_received_memories_date: z.string().datetime().nullish(),
  sign_in_count: z.number().int().nullish(),
  external_id: z.coerce.string().nullish(),
  time_zone: z.coerce.string().nullish(),
  memory_retention_days: z.number().int().nullish(),
  type: z.coerce.string().nullish(),
});
